import googleMeetIcon from './GoogleMeet/meet-24.png';
import msTeamsIcon from './MSTeams/teams-24.png';

export const VIDEO_CONF_NONE = 0;
export const VIDEO_CONF_GOOGLEMEET = 1;
export const VIDEO_CONF_MSTEAMS = 2;

export const VIDEO_CONF_PROVIDERS = [
  { id: VIDEO_CONF_NONE, label: 'none' },
  { id: VIDEO_CONF_MSTEAMS, label: 'msTeams', icon: msTeamsIcon },
  { id: VIDEO_CONF_GOOGLEMEET, label: 'googleMeet', icon: googleMeetIcon },
];

export const VIDEO_PROVIDER_STATUS_NONE = Symbol('Provider not active');
export const VIDEO_PROVIDER_STATUS_WORKING = Symbol('Provider sign in in progress');
export const VIDEO_PROVIDER_STATUS_SIGNED_IN = Symbol('Provider signed in');
export const VIDEO_PROVIDER_STATUS_ERROR = Symbol('Provider could not sign in');

export const VIDEO_CONF_BY_ID = VIDEO_CONF_PROVIDERS.reduce((acc, o) => ({ ...acc, [o.id]: o }), {});
